var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#638C9F",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.6,280H26.4C11.84,280,0,291.84,0,306.4v27.2C0,348.16,11.84,360,26.4,360h443.2c14.56,0,26.4-11.84,26.4-26.4v-27.2 C496,291.84,484.16,280,469.6,280z M464,328H32v-16h432V328z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,328c-8.848,0-16,7.168-16,16v112c0,8.832,7.152,16,16,16s16-7.168,16-16V344C112,335.168,104.848,328,96,328z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416,328c-8.848,0-16,7.168-16,16v112c0,8.832,7.152,16,16,16c8.848,0,16-7.168,16-16V344 C432,335.168,424.848,328,416,328z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416,376H96c-8.848,0-16,7.168-16,16c0,8.832,7.152,16,16,16h320c8.848,0,16-7.168,16-16C432,383.168,424.848,376,416,376 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,40c-8.848,0-16,7.168-16,16v32c0,8.832,7.152,16,16,16s16-7.168,16-16V56C112,47.168,104.848,40,96,40z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,216c-8.848,0-16,7.168-16,16v64c0,8.832,7.152,16,16,16s16-7.168,16-16v-64C112,223.168,104.848,216,96,216z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400,40c-8.848,0-16,7.168-16,16v32c0,8.832,7.152,16,16,16c8.848,0,16-7.168,16-16V56C416,47.168,408.848,40,400,40z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400,216c-8.848,0-16,7.168-16,16v64c0,8.832,7.152,16,16,16c8.848,0,16-7.168,16-16v-64C416,223.168,408.848,216,400,216 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496,72H16C7.152,72,0,79.168,0,88v80c0,8.832,7.152,16,16,16h480c8.848,0,16-7.168,16-16V88 C512,79.168,504.848,72,496,72z M480,152H32v-48h448V152z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496,152H16c-8.848,0-16,7.168-16,16v64c0,8.832,7.152,16,16,16h480c8.848,0,16-7.168,16-16v-64 C512,159.168,504.848,152,496,152z M480,216H32v-32h448V216z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfort);
export default __webpack_public_path__ + "static/media/comfort.e00e48e162867ac0478917e7d269c675.svg";
export { ForwardRef as ReactComponent };